import { render } from "./Historic.vue?vue&type=template&id=04f7a156&scoped=true"
import script from "./Historic.vue?vue&type=script&lang=js"
export * from "./Historic.vue?vue&type=script&lang=js"

import "./Historic.vue?vue&type=style&index=0&id=04f7a156&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-04f7a156"

export default script